import { render, staticRenderFns } from "./CanalInstagram.vue?vue&type=template&id=61d3f798&lang=pug"
import script from "./CanalInstagram.vue?vue&type=script&lang=js"
export * from "./CanalInstagram.vue?vue&type=script&lang=js"
import style0 from "./CanalInstagram.vue?vue&type=style&index=0&id=61d3f798&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports